import React, { useState } from 'react';

import { Button, Form, FormGroup, Label, Input, Col, Toast, ToastBody, ToastHeader } from 'reactstrap';

import { FaPhoneAlt, FaEnvelopeOpenText } from 'react-icons/fa';

function ContactForm() {

    const [contact, setContact] = useState({
        nombre: '',
        email: '',
        asunto: '',
        mensaje: '',
    })

    const handleInputChange = (event) => {
        setContact({
            ...contact,
            [event.target.name]: event.target.value
        })

    }
    const handleCheckChange = (event) => {

        setCheck(!event.target.checked);

    }

    // Extract values
    const {
        nombre,
        email,
        asunto,
        mensaje,
    } = contact;

    //Toast
    const [show, setShow] = useState(false);
    const [check, setCheck] = useState(true);

    const toggle = () => setShow(!show);

    //Send Form

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.target);

        fetch("/api/sendEmail", { method: "POST", body: data })
            .then(response => {
                toggle(response, 'Mensaje enviado')
            })
            .catch(err => console.log(err))

        setContact({
            nombre: '',
            email: '',
            asunto: '',
            mensaje: '',
        })
    }

    return (
        <>
            <div className="Form-Container">
                <div>
                    <Form onSubmit={handleSubmit} encType="multipart/form-data" className="Contact-Form" >
                        <h1>Contacta con Outsourcing Ingeniería de Procesos</h1>
                        <p>Para hacernos llegar su consulta rellene los campos del siguiente formulario:</p>
                        <FormGroup>
                            <Label>Nombre</Label>
                            <Input required type="text" name="nombre" placeholder="Nombre Completo" onChange={handleInputChange} value={nombre} />
                        </FormGroup>
                        <FormGroup>
                            <Label for="Email">Email</Label>
                            <Input required type="email" name="email" placeholder="Email" onChange={handleInputChange} value={email}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="Asunto">Asunto</Label>
                            <Input required type="text" name="asunto" placeholder="Asunto" onChange={handleInputChange} value={asunto}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="Mensaje">Mensaje</Label>
                            <Input required type="textarea" name="mensaje" onChange={handleInputChange} value={mensaje}/>
                        </FormGroup>
                        <FormGroup>
                            <Input style={{ marginRight: "0.35rem", marginLeft: "0", position: "relative"}} required type="checkbox" name="rgpd" onChange={handleCheckChange} />
                            <Label for="Rgpd">He leído y acepto la <a href="/politica-privacidad-proteccion-datos">política de privacidad</a> y autorizo el tratamiento de mis datos con las finalidades descritas.</Label>
                        </FormGroup>
                        <p className="Text-Legal-Form">Outsourcing Ingeniería de Procesos, le informa que los datos introducidos en el formulario serán tratados con la finalidad de
                        proporcionarle la información solicitada. Puede ejercer los derechos establecidos en los artículos 15 a 22 del Reglamento (UE)
                        2016/679 mediante el envío de un mensaje de correo electrónico a protecciondpd@oiprocesos.com. Para más información consulte
                        nuestra <a href="/politica-privacidad-proteccion-datos">Política de Privacidad</a>.</p>
                        <Button disabled={check} type="submit" className="Button-Form">Enviar</Button>
                    </Form>
                    <div className="Toast-Form">
                        <Toast isOpen={show}>
                            <ToastHeader toggle={toggle}>
                                HOLA! Queremos informarte
                            </ToastHeader>
                            <ToastBody>
                                Tu mensaje ha sido enviado con éxito.
                    </ToastBody>
                        </Toast>
                    </div>
                </div>

                <div>
                    <Col className="Direction-Contact">
                        <h1>Oficinas Centrales</h1>
                        <p className="Contact-Phrase">
                            Parque Empresarial San Fernando
                            Avda. de Castilla, 2
                            28830 San Fernando de Henares (Madrid)
                        </p>

                        <div className="Icons-Contact-Flex">
                            <FaPhoneAlt className="Icons-Contact" /> (+34) 91 740 72 50
                     <br />
                            <a href="#" className="Email-Contact"> <FaEnvelopeOpenText className="Icons-Contact" /> comunicacion@oiprocesos.com</a>
                        </div>
                    </Col>
                </div>
            </div>
        </>
    );
}

export default ContactForm;